import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface EditorProps {
  value: any;
  // onChange: (content: { en: string; ar: string }) => void;
  onChange: any;
  placeholder?: string;
  handlePublish: any;
  handleSave: any;
  language: string;
  changeLanguage: any;
  isPublished: boolean;
  hasChanges: boolean;
  isHelpModule?: boolean;
}

const RichTextEditor: React.FC<EditorProps> = ({
  value,
  onChange,
  handlePublish,
  handleSave,
  language,
  changeLanguage,
  isPublished,
  hasChanges,
  isHelpModule,
}) => {
  // const handleEditorChange = (content: string) => {
  //   onChange({
  //     ...value,
  //     [language]: content,
  //   });
  // };

  const modules = {
    toolbar: [["bold", "italic", "underline"], [{ list: "bullet" }, { list: "ordered" }], isHelpModule ? ["link", "image", "video"] : []],
  };

  // const getPlainText = (html: string) => {
  //   const div = document.createElement("div");
  //   div.innerHTML = html;
  //   return div.textContent || div.innerText || "";
  // };

  // const plainText = getPlainText(value[language] || "");
  // const isButtonActive = plainText.trim().length > 0;

  const handlePlaceholderValue = () => {
    let activeTab = window?.location?.pathname?.split("/")[2];
    let text = "";
    if (language === "en") {
      text = activeTab === "terms" ? "Enter Terms & Conditions..." : "Enter Privacy Policy";
    } else {
      text = activeTab === "terms" ? "أدخل الشروط والأحكام..." : "أدخل سياسة الخصوصية ...";
    }
    return text;
  };
  const getPublishLabel = () => {
    if (!isHelpModule) {
      if (hasChanges) return "SAVE & PUBLISH";
      return "PUBLISH";
    } else if (isHelpModule) {
      return "DELETE";
    }
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Language Tabs */}

      <div style={{ position: "absolute", left: isHelpModule ? "18rem" : "11rem", top: "0.5rem" }}>
        <div style={{ display: "flex", gap: "1rem", marginBottom: "0.5rem" }}>
          <button
            className="lang-button"
            onClick={() => changeLanguage("ar")}
            style={{
              borderBottom: language === "ar" ? "2px solid #20639B" : "none",
              border: "none",
              color: language === "ar" ? "#20639B" : "#BDBDBD",
            }}
          >
            Arabic
          </button>
          <button
            onClick={() => changeLanguage("en")}
            className="lang-button"
            style={{
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              borderBottom: language === "en" ? "2px solid #20639B" : "none",
              color: language === "en" ? "#20639B" : "#BDBDBD",
            }}
          >
            English
          </button>
        </div>
      </div>
      <div style={{ position: "absolute", right: "2rem", top: "0.5rem" }}>
        <div style={{ display: "flex", gap: "1rem", marginBottom: "0.5rem" }}>
          <button
            disabled={!isHelpModule && isPublished && !hasChanges}
            onClick={handlePublish}
            className={`publish-button ${!isHelpModule && isPublished && !hasChanges ? "inactive" : "active"}`}
          >
            {/* {isButtonActive ? "SAVE AND PUBLISH" : "PUBLISH"} */}
            {getPublishLabel()}
          </button>
          <button
            disabled={
              // (isPublished && !hasChanges) || (!isPublished && !hasChanges) || (isHelpModule && window?.location?.pathname?.includes("/help/help"))
              (isHelpModule && !hasChanges) || (isPublished && !hasChanges) || (!isPublished && !hasChanges)
            }
            onClick={handleSave}
            className={`publish-button ${isHelpModule && hasChanges && "enabled"}`}
          >
            SAVE
          </button>
        </div>
      </div>
      <div>
        <ReactQuill
          // key={language}
          value={value[language]}
          onChange={onChange}
          placeholder={handlePlaceholderValue()}
          modules={modules}
          className={language === "ar" ? "quill-rtl " : "quill-ltr"}
        />
      </div>
    </div>
  );
};

export default RichTextEditor;
